// The renderer historically received {path, name} pairs and later asked for
// file data by path. Web has no path semantics, so we keep a private File
// registry keyed by synthetic ids handed back in the `path` slot, preserving
// the caller contract (Feedback.jsx, submitFeedback saga).
const fileRegistry = new Map();
let nextFileId = 0;
const ACCEPT = 'image/png,image/jpeg,image/jpg';

const registerFile = (file) => {
  const id = `web-file://${++nextFileId}`;
  fileRegistry.set(id, file);
  return { path: id, name: file.name };
};

const readAsDataURL = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(reader.error);
  reader.readAsDataURL(file);
});

export const selectFiles = () =>
  new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = ACCEPT;
    input.multiple = true;
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);

    let settled = false;
    const cleanup = () => { input.remove(); };

    input.onchange = () => {
      if (settled) return;
      settled = true;
      const files = Array.from(input.files || []).map(registerFile);
      cleanup();
      resolve(files);
    };
    input.oncancel = () => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve([]);
    };
    window.addEventListener('focus', () => {
      setTimeout(() => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve([]);
      }, 500);
    }, { once: true });

    input.click();
  });

export const getFileData = async (filePathOrId) => {
  const file = fileRegistry.get(filePathOrId);
  if (!file) return null;
  const [buffer, dataUrl] = await Promise.all([
    file.arrayBuffer(),
    readAsDataURL(file),
  ]);
  return {
    buffer,
    mime: file.type || 'application/octet-stream',
    name: file.name,
    dataUrl,
  };
};
